/**
 * Ticket Type Badge Component
 *
 * Displays ticket type category.
 * Uses existing Badge component with neutral styling.
 */

import React from 'react';
import { Badge } from '../common/Badge';
import { TicketType } from '../../types/support';
import type { BadgeProps } from '../common/Badge';

export interface TicketTypeBadgeProps {
  /** Ticket type to display */
  type?: TicketType;

  /** Badge size */
  size?: BadgeProps['size'];
}

/**
 * Maps ticket type to human-readable label
 */
const getTypeLabel = (type: TicketType): string => {
  switch (type) {
    case TicketType.GENERAL_INQUIRY:
      return 'General Inquiry';
    case TicketType.APPLICATION_SUPPORT:
      return 'Application';
    case TicketType.AUDIT_QUESTION:
      return 'Audit';
    case TicketType.TRAINING_SUPPORT:
      return 'Training';
    case TicketType.PAYMENT_ISSUE:
      return 'Payment';
    case TicketType.CERTIFICATE_REQUEST:
      return 'Certificate';
    case TicketType.RENEWAL_SUPPORT:
      return 'Renewal';
    case TicketType.TECHNICAL_ISSUE:
      return 'Technical';
    case TicketType.COMPLAINT:
      return 'Complaint';
    case TicketType.FEEDBACK:
      return 'Feedback';
    default:
      return 'Unknown';
  }
};

export const TicketTypeBadge: React.FC<TicketTypeBadgeProps> = ({ type, size = 'md' }) => {
  if (!type) {
    return null;
  }

  const label = getTypeLabel(type);

  return (
    <Badge variant="default" size={size}>
      {label}
    </Badge>
  );
};
